import { Box, LinearProgress } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FileUpload, useFileUpload } from "src/context/FileUploadContext";

interface IUploadsByState {
    uploading: FileUpload[];
    pending: FileUpload[];
    completed: FileUpload[];
    error: FileUpload[];

}

const emptyUploadsByState: IUploadsByState = {
    completed: [],
    error: [],
    pending: [],
    uploading: []
}

const getUploadsByState = (uploads: FileUpload[]): IUploadsByState => {
    return {
        uploading: uploads.filter(x => x.status === 'uploading'),
        pending: uploads.filter(x => x.status === 'pending'),
        completed: uploads.filter(x => x.status === 'completed'),
        error: uploads.filter(x => x.status === 'error'),
    }
}

const hasUploads = (input: IUploadsByState): boolean => {
    return (input.completed.length + input.error.length + input.pending.length + input.uploading.length) > 0;
}

const getTotalProgress = (uploads: FileUpload[]): number => {
    if (uploads.length === 0) {
        return 0;
    }

    const totalBytes = uploads.map(x => x.progress.totalBytes).reduce((acc, current) => acc + current);
    const doneBytes = uploads.map(x => x.progress.doneBytes).reduce((acc, current) => acc + current);

    return (doneBytes / totalBytes) * 100;
}
const FileUploadHeader: FC = () => {

    const { uploads } = useFileUpload();

    const [uploadsByState, setUploadsByState] = useState<IUploadsByState>(emptyUploadsByState);

    useEffect(() => {
        setUploadsByState(getUploadsByState(uploads));
    }, [uploads])

    if (!hasUploads(uploadsByState)) {
        return (<></>);
    }

    return (
        <Box sx={{
            backgroundColor: 'background.default',
            color: 'text.primary',
            px: 2,
            py: 0.5,
            borderTop: 1,
            borderColor: 'divider'
        }}>
            <Box sx={{ fontSize: '0.875rem', mb: 0.5 }}>
                File uploads: {uploadsByState.pending.length} pending, {uploadsByState.uploading.length} uploading, {uploadsByState.completed.length} completed{(uploadsByState.error.length > 0 ? `, ${uploadsByState.error.length} failed` : '')}
            </Box>
            <LinearProgress
                variant='determinate'
                value={getTotalProgress(uploads)}
                sx={{
                    height: 4,
                    backgroundColor: 'action.disabled',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: 'primary.main'
                    }
                }}
            />
        </Box>
    )
}


export default FileUploadHeader;
